var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomShield = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.618 6.43a.801.801 0 0 0-.58-.661l-9.85-2.74a.8.8 0 0 0-.43 0l-9.85 2.74a.801.801 0 0 0-.579.661c-.057.411-1.36 10.119 1.983 14.948 3.34 4.823 8.265 6.059 8.473 6.11a.8.8 0 0 0 .376 0c.209-.051 5.135-1.287 8.474-6.11 3.343-4.83 2.04-14.537 1.983-14.948zm-4.292 5.668-6.72 6.719a.799.799 0 0 1-1.132 0l-4.155-4.155a.8.8 0 0 1 0-1.132l.825-.825a.801.801 0 0 1 1.133 0l2.763 2.763 5.328-5.328a.8.8 0 0 1 1.133 0l.825.825a.801.801 0 0 1 0 1.133z",
    fill: "#1E2969",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-shield.4b43c47afbe5dac13eb057ed979090d6.svg";